import { useEffect, useRef } from 'react';
import { trackMetaPageView } from './metaPixel';

export default function MetaPixelInit() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    if (!pixelId || pixelId.startsWith('%') || pixelId === 'undefined') return;

    try {
      if (!window.fbq) {
        window.fbq = function fbqShim() {
          window.fbq.callMethod
            ? window.fbq.callMethod.apply(window.fbq, arguments)
            : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];

        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
      }

      if (!window.__iv1MetaPixelActive) {
        window.fbq('init', pixelId);
        window.__iv1MetaPixelActive = true;
        window.__iv1MetaPixelId = pixelId;
        trackMetaPageView();
      }

      initialized.current = true;
    } catch (error) {
      console.warn('[MetaPixel] initialization skipped:', error.message);
    }
  }, []);

  return null;
}
